import React, { useContext } from 'react';
import { Link } from 'react-router-dom'; 
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { getData, postData, putData } from '../lib/utils';

import { Context } from "../components/contexts/AppContext";

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const [sessionData, setSessionData] = useState(null);
  const navigate = useNavigate();
  const sessionId = searchParams.get("session_id");
    const { value } = useContext(Context);
      const [appState, setAppState] = value;
        console.log("success app state ",appState.adminDetails)
  useEffect(() => {
   
 
    if (!sessionId) {
      navigate("/");
      return;
    }

   

        const fetchData = async () => {
            try {
              const response = await getData(`admin/verify-session/${sessionId}`);
 
               if(response)
               {
                
                 const response1 = await getData("admin/admin-details");                    
                      setAppState((prevState) => {
                        return { ...prevState, 
                          adminDetails:response1.admin,
                       
                        
                        };
                      });

                      console.log(response.metadata.plan," Success Page ",response.metadata)
                const obj ={
                  
                  plan:response.metadata.plan,
                  credits:parseFloat(response.metadata.credits),//1 is 5GB gb so 5 credit means 25600MB
                  type: "purchased",
                  purpose:"New Credits Purchased",
                  price: response.metadata.price

                } 
                const admin = response1?.admin || response1?.data?.admin;

if (admin?.id) {
  const res = await putData(`\admin/update-plan/${admin.id}`, 
    obj
  );

  if(res)
    {
    /*
      const resCredit = await postData(`admin/update-credit-history/${admin.id}`, 
        obj
      );
      if(resCredit){
        console.log("RESCREDIT ---- ",resCredit)
      }*/

     
    }
}
                
                    
               }
                    
            } catch (error) {
              console.error("Error fetching  details:", error);
             // navigate("/login");
            }
          };
          fetchData()
  }, [sessionId]);


  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-green-100 text-center p-4">
      <h1 className="text-4xl font-bold text-green-800 mb-4">Payment Successful! ✅</h1>
      <p className="text-lg text-gray-700 mb-6">
        Thank you for your purchase. Your payment has been received.
      </p>
      <Link to="/studio/galleries" className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700">
        Go to Dashboard
      </Link>
    </div>
  );
};

export default SuccessPage;
